module.exports = __webpack_public_path__ + "./fonts/PTSans-Bold.ttf";